<template>
    <transition name="container-transitions" mode="out-in">
        <div v-if="show">
            <AppTranslator style="position: fixed; right: 20px; top: 15px"/>
            <div class="background kt-grid kt-grid--ver kt-grid--root kt-page">
                <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v4 kt-login--signin" id="kt_login">
                    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                        <div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper">
                            <div class="kt-login__container">
                                <div class="kt-login__logo">
                                    <a href="#">
                                        <img :src="loginImage" class="img-fluid" style="max-height: 182px">
                                    </a>
                                </div>
                                <div class="kt-login__head">
                                    <h3 class="kt-login__title">{{ $t('AppSignUp.Quero me cadastrar') }}</h3>
                                    <div class="kt-login__desc">
                                    </div>
                                </div>
                                <form class="kt-form" @submit.prevent autocomplete="off">
                                    <div class="input-group">
                                        <app-input class="form-control" type="text" :placeholder="$t('AppSignUp.Nome')"
                                                   v-model="form.first_name"
                                                   :class="{'is-invalid' : $v.form.first_name.$invalid && $v.form.first_name.$dirty}"
                                        ></app-input>
                                        <span class="form-text error"
                                              v-if="$v.form.first_name.$invalid && $v.form.first_name.$dirty">
                                           {{ $t('AppSignUp.Nome obrigatório') }}
                                        </span>
                                    </div>
                                    <div class="input-group">
                                        <app-input class="form-control" type="text"
                                                   :placeholder="$t('AppSignUp.Sobrenome')"
                                                   v-model="form.last_name"
                                                   :class="{'is-invalid' : $v.form.last_name.$invalid && $v.form.last_name.$dirty}">
                                        </app-input>
                                        <span class="form-text error"
                                              v-if="$v.form.last_name.$invalid && $v.form.last_name.$dirty">
                                              {{ $t('AppSignUp.Sobrenome obrigatório') }}
                                        </span>
                                    </div>
                                    <div class="input-group">
                                        <app-input class="form-control" type="password"
                                                   :placeholder="$t('AppSignUp.Senha')"
                                                   v-model="form.password"
                                                   :class="{'is-invalid' : $v.form.password.$invalid && $v.form.password.$dirty}">
                                        </app-input>
                                        <span class="form-text error" v-if="$v.form.password.$invalid && $v.form.password.$dirty">
                                            {{ $t('AppSignUp.A senha deve possuir entre 8 e 64 caracteres e ao menos um caracter maiúsculo, um minúsuclo e um caracter especial') }}
                                        </span>
                                    </div>
                                    <div class="input-group">
                                        <app-input class="form-control" type="password"
                                                   :placeholder="$t('AppSignUp.Confirmar senha')"
                                                   v-model="form.confirm_password"
                                                   :class="{'is-invalid' : $v.form.confirm_password.$invalid && $v.form.confirm_password.$dirty}">
                                        </app-input>
                                        <span class="form-text error"
                                              v-if="$v.form.confirm_password.$invalid && $v.form.confirm_password.$dirty">
                                              {{ $t('AppSignUp.A confirmar senha não confere') }}
                                        </span>
                                    </div>
                                    <br>
                                    <div class="form-group">
                                        <label class="kt-checkbox tos-text">
                                            <input type="checkbox" v-model="$v.form.tos_accepted.$model">
                                            {{ $t('AppSignUp.Aceito os') }}
                                            <a :href="termsOfUse" target="_blank">
                                                {{ $t('AppSignUp.Termos de Uso') }}
                                            </a>
                                            {{ $t('AppSignUp.e') }}
                                            <a :href="privacyPolicy" target="_blank">
                                                {{ $t('AppSignUp.Política de Privacidade') }}
                                            </a>
                                            <span :class="{'is-invalid' : $v.form.tos_accepted.$invalid && $v.form.tos_accepted.$dirty}"></span>
                                        </label>
                                        <span class="form-text error" v-if="$v.form.tos_accepted.$invalid && $v.form.tos_accepted.$dirty">
                                           {{ $t('AppSignUp.É obrigatorio aceitar os termos e condições') }}
                                        </span>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-sm-12 text-center">
                                            <app-button type="primary" @handleClick="validateForm" size="lg">
                                                {{ $t('AppSignUp.Cadastrar') }}
                                            </app-button>&nbsp;&nbsp;
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog header=" " :visible.sync="openModalAccCreated" :style="{width: '30vw'}" :modal="true"
                    style="text-align: center">
                <span class="pi pi-check-circle" style="font-size: 7em"></span>
                <br><br>
                <p style="text-align: center; font-size: 1.3em">
                    {{ $t('AppSignUp.Conta criada com sucesso') }}
                </p>
                <template #footer>
                    <Button :label="$t('AppSignUp.Fechar')" @click="closeModalAccCreated" autofocus/>
                </template>
            </Dialog>
        </div>
    </transition>
</template>
<script>

import AppButton from '@/components/common/AppButton.vue'
import AppInput from '@/components/common/AppRegisterInput.vue'

import {helpers, required, sameAs} from "vuelidate/lib/validators";
import {router} from '@/router';
import axios from 'axios';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog'
import AppTranslator from "@/components/common/AppTranslator.vue";

const mustBeTrue = (value) => value === true;

// "Maximum password length should be at least 64 characters to allow passphrases" - OWASP Cheat Sheet Series
const MAX_PASSWORD_LENGTH = 64;
const MIN_PASSWORD_LENGTH = 8;
const SPECIAL_CHARACTERS = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
const LOWER_CASE = /[a-z]/;
const UPPER_CASE = /[A-Z]/;
const passwordValidation = helpers.withParams(
    { type: 'passwordValidation' },
    value => {
        const hasRequiredLength = MIN_PASSWORD_LENGTH <= value.length && value.length <= MAX_PASSWORD_LENGTH;
        const hasSpecialCharacter = SPECIAL_CHARACTERS.test(value);
        const hasLowerCaseCharacter = LOWER_CASE.test(value);
        const hasUpperCaseCharacter = UPPER_CASE.test(value);

        return hasRequiredLength && hasSpecialCharacter && hasLowerCaseCharacter && hasUpperCaseCharacter;
    }
);

export default {
    data() {
        return {
            show: false,
            loginImage: require("../../../assets/images/brands/" + process.env.VUE_APP_THEME_IMAGE_LOGIN + ".png"),
            locale: navigator.language || navigator.userLanguage,
            form: {
                password: null,
                confirm_password: null,
                first_name: null,
                last_name: null,
                tos_accepted: null
            },
            open_tos: false,
            openModalAccCreated: false,
        }
    },
    mounted() {
        this.inviteId = this.$route.query.invite_id;
        this.fade();
    },
    beforeDestroy() {
        this.fade();
    },
    methods: {
        fade() {
            this.show = !this.show;
        },
        validateForm() {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppSignUp.Formulário com valores inválidos'),
                    life: 5000
                });
            } else {
                this.createUser();
            }
        },
        createUser() {
            var vm = this;
            axios.post(process.env.VUE_APP_BACKEND_ADDRESS + '/api/v3/invites/' + this.inviteId + '/sign-up', {
                    password: this.form.password,
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    tos_accepted: this.form.tos_accepted
                }
            ).then(function (response) {
                vm.showModalAccCreated();
            }).catch((error) => {
                if (error.response && error.response.data && error.response.data.details) {
                    this.$toast.add({
                        severity: 'error',
                        summary: error.response.data.details,
                        life: 5000
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppSignUp.Não foi possível criar a sua conta, tente mais tarde'),
                        life: 5000
                    });
                }

            });
        },
        showModalAccCreated() {
            this.openModalAccCreated = true;
        },
        closeModalAccCreated() {
            this.openModalAccCreated = false;
            router.push({name: 'login'});
        },
    },
    computed: {
        termsOfUse: function () {
            if (this.$i18n.locale === 'pt') {
                return 'https://iotag.com.br/termos/'
            }

            if (this.$i18n.locale === 'es') {
                return 'https://iotag.com.br/terminos/'
            }

            if (this.$i18n.locale === 'en') {
                return 'https://iotag.com.br/terms/'
            }

            return 'https://iotag.com.br/termos/'
        },
        privacyPolicy: function () {
            if (this.$i18n.locale === 'pt') {
                return 'https://iotag.com.br/privacidade/'
            }

            if (this.$i18n.locale === 'es') {
                return 'https://iotag.com.br/privacidad/'
            }

            if (this.$i18n.locale === 'en') {
                return 'https://iotag.com.br/privacy/'
            }

            return 'https://iotag.com.br/privacidade/'
        },
    },
    components: {
        AppTranslator,
        AppButton, AppInput, Dialog, Button
    },
    validations: {
        form: {
            password: {required, passwordValidation},
            confirm_password: {required, sameAsPassword: sameAs('password')},
            first_name: {required},
            last_name: {required},
            tos_accepted: {required, mustBeTrue},
        }
    },

}
</script>

<style scoped>
@import "../../../assets/styles/login-4.css";

a {
    color: #00aff0;
    text-decoration: underline;
}

.error {
    width: 100%;
    margin-top: .25rem;
    font-size: 100%;
    color: #fd397a;
}


.is-invalid {
    border-color: #fd397a;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(253, 57, 122, 0.25);
    box-shadow: 0 0 0 0.2rem rgba(253, 57, 122, 0.25);
}

.container-transitions-enter-active {
    transition-duration: 2.1s !important;
    transition-property: opacity !important;
    transition-timing-function: ease !important;
}

.container-transitions-enter, .container-transitions-leave-active {
    opacity: 0 !important;
}

.tos-text {
    font-size: 1.25rem;
    color: #ffffff;
}


</style>
